import { FormDataHubAdjustmentTaxInvoice } from '@/form/form-data/FormDataHubAdjustmentTaxInvoice';
export class RequestDataPutTaxInvoicer extends FormDataHubAdjustmentTaxInvoice {
    // implements IRequetData
    constructor(data) {
        super();
        Object.assign(this, {
            ...data,
        });
    }
    makeData() {
        const { businessName, ceoName, businessCondition, businessType, address, contactName, contactTelephone, } = this;
        let { contactEmail, } = this;
        if (!contactEmail) {
            contactEmail = null;
        }
        return {
            businessName,
            ceoName,
            businessCondition,
            businessType,
            address,
            contactEmail,
            contactName,
            contactTelephone,
        };
    }
}
